/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/upperCaseFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoOutsideClick implements angular.IDirective {
        restrict = "A";
        scope = {
            boundModel: "=",
            elementId: "@",
            defaultValue: "=?"
        }
        private $rootScope: angular.IRootScopeService;

        constructor($rootScope: angular.IRootScopeService) {
            this.$rootScope = $rootScope;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.token = Date.now();

            this.$rootScope.$broadcast('meevo-outside-click', { id: scope.elementId, token: scope.token });

            var onMeevoOutsideClick = function (event, args) {
                if (scope.token != args.token) {
                    return;
                }
                if (scope.elementId != args.id) {
                    scope.boundModel = false;
                    //this.$rootScope.$apply(function () {})
                }
            };
            const deregisterOutsideClick = this.$rootScope.$on('meevo-outside-click', onMeevoOutsideClick);

            if (!_.isUndefined(scope.defaultValue)) {
                // if defaultValue isn't provided, set it to false
                // allows you to set the initial value of the bound model
                setTimeout(function () {
                    scope.boundModel = scope.defaultValue;
                }, 200);

            }

            var onBodyClick = function (event) {
                if (scope.boundModel != false) {
                    if (angular.element(scope.elementId).find(event.target).length == 0) {
                        scope.$apply(function () { scope.boundModel = false });
                    }
                }
            }

            //element id needs to have the id or class that is unique. eg: element-id="#membership-dropdown"
            angular.element('body')
                .off('click', onBodyClick)
                .on('click', onBodyClick);

            scope.$on('$destroy', () => {
                deregisterOutsideClick();
                angular.element('body').off('click', onBodyClick);
            });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope) => {
                return new MeevoOutsideClick($rootScope );
            };
            directive.$inject = ['$rootScope']
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoOutsideClick", MeevoOutsideClick.factory());
}